<script setup>
// import SpinnerHtml from "../components/SpinnerHtml.vue"
</script>
<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center p-3 my-3 text-dark-50 bg-lightblue rounded shadow-sm">
          <div class="lh-100">
            <h6 class="border-bottom border-gray pb-2 mb-0 lh-100">MATRIMONY LEADS</h6>
          </div>
          <button type="submit" class="btn btn-success ml-auto" @click="openModelClickMethod" data-toggle="modal"
                  data-target="#exampleModal">
            <span> &#43; &nbsp;New</span>
          </button>
        </div>
        <div class="ag-grid-container">
          <div class="example-wrapper">
            <div class="example-header mb-2">
              <input type="text" class="form-control" id="filter-text-box" placeholder="Search here..."
                     @input="onFilterTextBoxChanged">
            </div>
            <ag-grid-vue
                style="width: 100%; height: 600px;"
                class="ag-theme-alpine"
                :columnDefs="columnDefs"
                @grid-ready="onGridReady"
                :defaultColDef="defaultColDef"
                :rowData="tables"
                :context="gridContext"
                :suppressBrowserResizeObserver="true"
                :cacheQuickFilter="true"
                :pagination="true"
                :paginationPageSize="50">
            </ag-grid-vue>
          </div>
        </div>
      </div>
    </div>
    <!--    model begin-->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
         aria-labelledby="exampleModalLabel"
         aria-hidden="true">
      <div class="modal-dialog" :class="modalSize" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">New Lead Integration</h5>
            <button type="button" ref="modalClose" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit="onSubmit">
            <div class="modal-body">
              <div class="form-group">
                <label for="integration-name" class="col-form-label">Name:<span
                    class="text-danger">*</span></label>
                <input type="text" class="form-control" maxlength="30" v-model="form.name" id="integration-name"
                       required>
              </div>
              <div class="form-group">
                <label for="integration-phonenumber" class="col-form-label">Integration Number:<span
                    class="text-danger">*</span></label>
                <input
                    id="integrated_number"
                    ref="integratedNumberInput"
                    v-model="integratedNumberSearch"
                    class="form-control"
                    type="text"
                    list="integrated-number-options"
                    placeholder="Search by name or phone number"
                    autocomplete="off"
                    @input="onIntegratedNumberInput"
                    @change="selectIntegratedNumber"
                    required
                >
                <datalist id="integrated-number-options">
                  <option v-for="(option, key) in phones" :key="key"
                          :value="getIntegratedNumberLabel(option)"></option>
                </datalist>
              </div>
              <div v-show="form.integrationNumber">
                <div class="form-group">
                  <label class="col-form-label" for="pasteRadio">Select matching type:<span
                      class="text-danger">*</span></label>
                  &nbsp;
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="matchType" id="pasteRadioAll" value="All"
                           v-model="form.matchType" @change="getChangeMatch" required>
                    <label class="form-check-label" for="pasteRadioAll">All</label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="matchType" id="pasteRadio" value="Exact"
                           v-model="form.matchType" checked="true" @change="getChangeMatch" required>
                    <label class="form-check-label" for="pasteRadio">Exact</label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="matchType" id="uploadRadio" value="Partial"
                           v-model="form.matchType" @change="getChangeMatch" required>
                    <label class="form-check-label" for="uploadRadio">Partial</label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="matchType" id="recentRadio" value="Image"
                           v-model="form.matchType" @change="getChangeMatch" required>
                    <label class="form-check-label" for="recentRadio">Image</label>
                  </div>
                </div>
                <div class="form-group" v-if="['Exact', 'Partial'].includes(form.matchType)">
                  <label for="integration-phonenumber-id" class="col-form-label">Matching Word:<span
                      class="text-danger">*</span> <span class="text-info" v-show="form.matchType == 'Exact'"> [Comma separated allowed]</span></label>
                  <input type="text" class="form-control" minlength="2" maxlength="100" v-model="form.matchingWord"
                         id="integration-phonenumber-id" :required="form.matchType !== 'Image'">
                </div>
                <div class="form-group">
                  <label class="col-form-label" for="pasteRadio">Purpose:<span class="text-danger">*</span></label>
                  &nbsp;
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="purposeType" id="purposeType0" value="0"
                           v-model="form.purposeType" checked="true" @change="getChangeEvent(1)" required>
                    <label class="form-check-label" for="purposeType0">All</label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="purposeType" id="purposeType1" value="1"
                           v-model="form.purposeType" @change="getChangeEvent(2)" required>
                    <label class="form-check-label" for="purposeType1">Google Sheet Lead</label>
                  </div>

                  <div class="form-check form-check-inline" v-show="form.matchType == 'Exact'">
                    <input class="form-check-input" type="radio" name="purposeType" id="purposeType2" value="2"
                           v-model="form.purposeType" @change="getChangeEvent(3)" required>
                    <label class="form-check-label" for="purposeType2">Auto-reply</label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="purposeType" id="purposeType3" value="3"
                           v-model="form.purposeType" @change="getChangeEvent(4)" required>
                    <label class="form-check-label" for="purposeType3">Webhook</label>
                  </div>
                </div>
                <div v-show="['0', '1'].includes(form.purposeType)">
                  <hr/>
                  <div class="form-group">
                    <label for="integration-whatsApp-id" class="col-form-label">Deployment ID:<span
                        class="text-danger">*</span></label>
                    <input type="text" class="form-control" minlength="30" maxlength="100" v-model="form.deploymentID"
                           id="integration-whatsApp-id" :required="['0', '1'].includes(form.purposeType)">
                  </div>
                  <div class="form-group">
                    <label for="integration-whatsApp-id" class="col-form-label">Sheet Name:<span
                        class="text-primary"> (Default: Sheet1)</span></label>
                    <input type="text" class="form-control" minlength="1" maxlength="30" v-model="form.sheetName"
                           id="integration-whatsApp-id">
                  </div>
                </div>
                <div v-show="['0', '2'].includes(form.purposeType) && form.matchType == 'Exact'">
                  <hr/>
                  <div class="form-group">
                    <label for="template" class="col-form-label">Choose Template <span
                        class="text-danger">*</span></label>
                    <select class="form-control" id="template" v-model="form.template" @change="templateOnChange"
                            :disabled="validated == 1"
                            :required="['0', '2'].includes(form.purposeType) && form.matchType == 'Exact'">
                      <option value=""> -- Choose --</option>
                      <option v-for="(option, key) in templates" :value="key" :key="key"
                              v-show="option.status == 'APPROVED'">
                        {{
                          option.name
                        }} [{{ option.category }}]
                      </option>
                    </select>
                  </div>
                  <div style="background-color: antiquewhite;padding: 12px;border-radius: 5px;" v-show="preview">
                    <span v-html="preview"></span>
                  </div>
                  <div v-for="(divItem, divKey) in dynamicVariables" :key="divKey">
                    <div class="form-group" v-for="(divItem1, divKey1) in divItem" :key="divKey1">
                      <label for="xlsxHead" class="col-form-label">COMMON {{ divKey }} {{ divKey1 + 1 }} <span
                          class="text-danger">*</span></label>
                      <input type="text" class="form-control" minlength="5" maxlength="150"
                             id="integration-phonenumber" :placeholder="`Enter COMMON ${divKey} ${divKey1 + 1}`"
                             v-model="form.xlsxHead[divKey][divKey1]"
                             @input="templateOnDynamicChange(divKey, divKey1, form.xlsxHead[divKey][divKey1], true)"
                      >
                    </div>
                  </div>
                </div>
                <div v-show="['0', '3'].includes(form.purposeType)">
                  <hr/>
                  <div class="form-group">
                    <label for="integration-webhook-url-id" class="col-form-label">Webhook URL:<span
                        class="text-danger" v-show="['3'].includes(form.purposeType)">*</span></label>
                    <input type="text" class="form-control" minlength="30" maxlength="255" v-model="form.webhookURL"
                           id="integration-webhook-url-id" :required="['3'].includes(form.purposeType)">
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-primary">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--    model end-->
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment/moment";
import {AgGridVue} from "ag-grid-vue3";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

export default {
  components: {
    'ag-grid-vue': AgGridVue,
  },
  data() {
    return {
      form: {
        name: '',
        integrationNumber: '',
        matchingWord: '',
        matchType: 'Exact',
        purposeType: '1',
        deploymentID: '',
        webhookURL: '',
        sheetName: '',
        template: '',
        xlsxHead: {
          'HEADER_DOCUMENT': [],
          'HEADER_IMAGE': [],
          'HEADER_VIDEO': [],
          'HEADER_TEXT': [],
          'BODY_TEXT': [],
          'FOOTER_TEXT': [],
          'BUTTON_URL': [],
          'BUTTON_PAYLOAD': []
        }
      },
      formTemp: {
        name: '',
        integrationNumber: '',
        matchingWord: '',
        matchType: 'Exact',
        purposeType: '1',
        deploymentID: '',
        webhookURL: '',
        sheetName: '',
        template: '',
        xlsxHead: {
          'HEADER_DOCUMENT': [],
          'HEADER_IMAGE': [],
          'HEADER_VIDEO': [],
          'HEADER_TEXT': [],
          'BODY_TEXT': [],
          'FOOTER_TEXT': [],
          'BUTTON_URL': [],
          'BUTTON_PAYLOAD': []
        }
      },
      modalSize: 'modal-md',
      editID: '',
      templates: [],
      preview: '',
      xlsxHead: [],
      dynamicVariables: [],
      previewShow: false,
      phones: [],
      integratedNumberSearch: '',
      tables: [],
      show: true,
      gridApi: null,
      gridContext: null,
      resizeObserverErrorHandler: null,
      columnDefs: [],
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
      }
    }
  },
  mounted() {
    this.resizeObserverErrorHandler = (event) => {
      const msg = event?.message || event?.error?.message || '';
      if (msg.includes('ResizeObserver loop completed with undelivered notifications')) {
        event.stopImmediatePropagation();
      }
    };
    window.addEventListener('error', this.resizeObserverErrorHandler);
  },
  beforeUnmount() {
    if (this.resizeObserverErrorHandler) {
      window.removeEventListener('error', this.resizeObserverErrorHandler);
    }
  },
  async created() {
    this.gridContext = {componentParent: this};
    this.columnDefs = this.getColumnDefs();
    var getTemp = await this.getNumberIntegrationList();
    this.tables = getTemp.data.message;
    const templateURL = '/whatsApp/number_integration_list';
    var getWaId = await this.axiosRequest(templateURL, {
      waId: this.waId
    });
    const updatedData = getWaId.data.message.map(obj => ({
      ...obj,
      phonenumber: `91${obj.phonenumber}`
    }));
    this.phones = updatedData;
  },
  methods: {
    getIntegratedNumberLabel(option) {
      return `${option.name} (+91 ${option.phonenumber})`;
    },
    onIntegratedNumberInput() {
      const selectedPhone = this.phones.find(
          (option) => option.phonenumber === this.form.integrationNumber
      );
      if (!selectedPhone || this.integratedNumberSearch !== this.getIntegratedNumberLabel(selectedPhone)) {
        this.form.integrationNumber = '';
        this.$refs.integratedNumberInput.setCustomValidity('Please select an integrated number from the list.');
      }
    },
    async selectIntegratedNumber() {
      const selectedPhone = this.phones.find(
          (option) => this.getIntegratedNumberLabel(option) === this.integratedNumberSearch.trim()
      );

      if (!selectedPhone) {
        this.form.integrationNumber = '';
        this.$refs.integratedNumberInput.setCustomValidity('Please select an integrated number from the list.');
        return;
      }

      this.form.integrationNumber = selectedPhone.phonenumber;
      this.$refs.integratedNumberInput.setCustomValidity('');
      await this.getChangeEvent(0);
    },
    getColumnDefs() {
      return [
        {headerName: 'NAME', field: 'name', flex: 1.2},
        {headerName: 'INTEGRATION NUMBER', field: 'integrationNumber', flex: 1.2},
        {headerName: 'MATCHING WORD', field: 'matchingWord', flex: 1.4},
        {headerName: 'MATCH TYPE', field: 'matchType', flex: 1},
        {headerName: 'SHEET NAME', field: 'sheetName', flex: 1},
        {
          headerName: 'DATETIME',
          field: 'timestamp',
          flex: 1.2,
          valueFormatter: (params) => params.value ? moment(params.value).format('DD-MM-YYYY hh:mm:ss a') : ''
        },
        {
          headerName: 'ACTION',
          field: '_id',
          flex: 2.3,
          sortable: false,
          filter: false,
          cellRenderer: (params) => {
            const rowId = params.data?._id;
            const wrapper = document.createElement('div');
            wrapper.className = 'd-flex align-items-center flex-wrap gap-1';

            const createButton = (label, className, mode, attrs = {}) => {
              const btn = document.createElement('button');
              btn.type = 'button';
              btn.className = className;
              btn.textContent = label;
              Object.keys(attrs).forEach((key) => btn.setAttribute(key, attrs[key]));
              btn.addEventListener('click', () => {
                params.context.componentParent.integrationActionById(rowId, mode);
              });
              return btn;
            };

            wrapper.appendChild(createButton('Edit', 'btn btn-success btn-sm mr-1', 'edit', {
              'data-toggle': 'modal',
              'data-target': '#exampleModal'
            }));
            wrapper.appendChild(createButton('Delete', 'btn btn-danger btn-sm mr-1', 'delete'));
            if (params.data?.enable) {
              wrapper.appendChild(createButton('Active', 'btn btn-primary btn-sm', 'disable'));
            } else {
              wrapper.appendChild(createButton('In-Active', 'btn btn-warning btn-sm', 'enable'));
            }
            return wrapper;
          }
        }
      ];
    },
    onGridReady(params) {
      this.gridApi = params.api;
    },
    onFilterTextBoxChanged() {
      if (!this.gridApi) return;
      this.gridApi.setQuickFilter(document.getElementById('filter-text-box').value);
    },
    integrationActionById(rowId, mode) {
      const rowIndex = this.tables.findIndex((row) => row._id === rowId);
      if (rowIndex < 0) return;
      this.integrationAction(rowIndex, mode);
    },
    async onSubmit(event) {
      event.preventDefault()
      if (confirm('Are you sure to save?')) {
        this.begin_loading()
        var form = new FormData();
        form.append('name', this.form.name);
        form.append('integrationNumber', this.form.integrationNumber);
        form.append('matchingWord', this.form.matchingWord);
        form.append('matchType', this.form.matchType);
        form.append('purposeType', this.form.purposeType);
        form.append('deploymentID', this.form.deploymentID);
        form.append('webhookURL', this.form.webhookURL);
        form.append('sheetName', this.form.sheetName);
        // const config = {
        //   // 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
        //   // headers: {
        //   //   'Content-Type': 'multipart/form-data'
        //   // }
        // }
        const NMPUSER = JSON.parse(localStorage.getItem('NMPUSER'))
        if (!(localStorage.getItem('NMPUSER') && NMPUSER && Object.prototype.hasOwnProperty.call(NMPUSER, "token") && NMPUSER.token && NMPUSER.token == this.waId && NMPUSER.token != "")) {
          this.$router.push('/');
          return false;
        }
        const config = {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': NMPUSER.token,
          }
        }
        await axios.post('/whatsApp/mat/number_integration',
            {
              name: this.form.name,
              integrationNumber: this.form.integrationNumber,
              matchingWord: this.form.matchingWord,
              matchType: this.form.matchType,
              purposeType: this.form.purposeType,
              deploymentID: this.form.deploymentID,
              webhookURL: this.form.webhookURL,
              sheetName: this.form.sheetName,
              templateName: JSON.stringify(this.templates[this.form.template]),
              xlsxHead: JSON.stringify(this.form.xlsxHead),
              editID: this.editID,
            }, // the data to post
            config).then(response => {
          var responseTitle;
          if (response.data.status) {
            responseTitle = {title: "Success", icon: "success"};
          } else {
            responseTitle = {title: "Failed", icon: "error"};
          }
          this.$swal({
            title: responseTitle.title,
            html: response.data.message,
            icon: responseTitle.icon,
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        });
        this.end_loading()
        this.integratedNumberSearch = '';
        this.form = {
          name: '',
          integrationNumber: '',
          matchingWord: '',
          matchType: 'Exact',
          purposeType: '1',
          deploymentID: '',
          webhookURL: '',
          sheetName: '',
          template: '',
          xlsxHead: {
            'HEADER_DOCUMENT': [],
            'HEADER_IMAGE': [],
            'HEADER_VIDEO': [],
            'HEADER_TEXT': [],
            'BODY_TEXT': [],
            'FOOTER_TEXT': [],
            'BUTTON_URL': [],
            'BUTTON_PAYLOAD': []
          }
        };
        this.editID = ''
        this.$refs.modalClose.click();
        var getTemp = await this.getNumberIntegrationList();
        this.tables = getTemp.data.message;
      }
    }, onFileChange(event) {
      this.form.fileUpload = event.target.files[0]
    },
    onReset(event) {
      event.preventDefault()
      // Reset our form values
      this.form.template = ''
      this.form.name = ''
      this.form.food = null
      this.form.checked = []
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    getChangeMatch() {
      if (this.form.matchType == 'Exact') { // reset field values

      } else {
        this.form.template = ''
        this.form.xlsxHead = {
          'HEADER_DOCUMENT': [],
          'HEADER_IMAGE': [],
          'HEADER_VIDEO': [],
          'HEADER_TEXT': [],
          'BODY_TEXT': [],
          'FOOTER_TEXT': [],
          'BUTTON_URL': [],
          'BUTTON_PAYLOAD': []
        }
        this.dynamicVariables = []
        this.preview = ""
        this.templates = [];
      }
      // this.getChangeEvent()
      // this.form.deploymentID = ''
      // this.form.webhookURL = ''
      // this.form.sheetName = ''

    },
    async getChangeEvent(getEvent) {
      const modalSizeArray = ['modal-lg', 'modal-md', 'modal-lg', 'modal-md'];
      const purposeType = parseInt(this.form.purposeType, 10);
      const modalSize = modalSizeArray.length > purposeType ? modalSizeArray[purposeType] : 'modal-md';
      this.modalSize = modalSize;
      const selectedPhone = this.phones.find(
          p => p.phonenumber === this.form.integrationNumber
      );
      console.log(this.formTemp)
      if (parseInt(getEvent) === 0) { // template changes
        this.form = {
          name: this.form.name,
          integrationNumber: this.form.integrationNumber,
          matchingWord: '',
          matchType: 'Exact',
          purposeType: '1',
          deploymentID: '',
          webhookURL: '',
          sheetName: '',
          template: '',
          xlsxHead: {
            'HEADER_DOCUMENT': [],
            'HEADER_IMAGE': [],
            'HEADER_VIDEO': [],
            'HEADER_TEXT': [],
            'BODY_TEXT': [],
            'FOOTER_TEXT': [],
            'BUTTON_URL': [],
            'BUTTON_PAYLOAD': []
          }
        };
      } else if (parseInt(getEvent) === 1) { // all
        this.form.deploymentID = this.formTemp.deploymentID
        this.form.webhookURL = this.formTemp.webhookURL
        this.form.sheetName = this.formTemp.sheetName
        this.form.template = this.formTemp.template
        this.form.xlsxHead = this.formTemp.xlsxHead
      } else if (parseInt(getEvent) === 2) { // google sheet
        this.form.deploymentID = this.formTemp.deploymentID
        this.form.sheetName = this.formTemp.sheetName
        this.form.webhookURL = ""
        this.form.template = ""
        this.form.xlsxHead = {
          'HEADER_DOCUMENT': [],
          'HEADER_IMAGE': [],
          'HEADER_VIDEO': [],
          'HEADER_TEXT': [],
          'BODY_TEXT': [],
          'FOOTER_TEXT': [],
          'BUTTON_URL': [],
          'BUTTON_PAYLOAD': []
        }
      } else if (parseInt(getEvent) === 3) { // auto-reply
        this.form.deploymentID = ""
        this.form.webhookURL = ""
        this.form.sheetName = ""
        this.form.template = this.formTemp.template
        this.form.xlsxHead = this.formTemp.xlsxHead
      } else if (parseInt(getEvent) === 4) { // webhook
        this.form.deploymentID = ""
        this.form.webhookURL = this.formTemp.webhookURL
        this.form.sheetName = ""
        this.form.template = ""
        this.form.xlsxHead = {
          'HEADER_DOCUMENT': [],
          'HEADER_IMAGE': [],
          'HEADER_VIDEO': [],
          'HEADER_TEXT': [],
          'BODY_TEXT': [],
          'FOOTER_TEXT': [],
          'BUTTON_URL': [],
          'BUTTON_PAYLOAD': []
        }
      } else {
        this.form.deploymentID = ''
        this.form.webhookURL = ''
        this.form.sheetName = ''
        this.form.template = ''
        this.form.xlsxHead = {
          'HEADER_DOCUMENT': [],
          'HEADER_IMAGE': [],
          'HEADER_VIDEO': [],
          'HEADER_TEXT': [],
          'BODY_TEXT': [],
          'FOOTER_TEXT': [],
          'BUTTON_URL': [],
          'BUTTON_PAYLOAD': []
        }
      }
      this.dynamicVariables = []
      this.preview = ""
      this.templates = [];
      console.log("template", this.form.template)
      const purposeTypeTemp = parseInt(this.form.purposeType, 10);
      if (selectedPhone && [0, 2].includes(purposeType) && [0, 2].includes(purposeTypeTemp) && this.form.matchType == 'Exact') { //  && [0, 2].includes(purposeType)
        console.log(selectedPhone);
        console.log(selectedPhone.whatsAppId);
        if (selectedPhone.whatsAppId && selectedPhone.token.length > 100 && selectedPhone.msg91 == false) {
          const getNumberObj = await this.getTemplates(selectedPhone.whatsAppId)
          if (getNumberObj.data.status && getNumberObj.data.data.data)
            this.templates = getNumberObj.data.data.data;

          if (this.formTemp?.reply?.template?.name) {
            const matchedIndex = this.templates.findIndex(
                t => t.name === this.formTemp.reply.template.name
            );
            console.log("matchedIndex ", matchedIndex)

            this.form.template = matchedIndex
            // this.templates[this.form.template] = this.tables[index].reply.template
            this.templateOnChange(false)

            // set innerHtml begin
            setTimeout(() => {
              var previewData = this.extractPreviewData(this.formTemp.reply.data)
              console.log(previewData)
              previewData.forEach(component => {
                component.values.forEach((item, index) => {
                  if (item.type === "text") {
                    let selector = `span.${component.type}_${item.type} i:nth-child(${index + 1})`;
                    let el = document.querySelector(selector);
                    if (el) {
                      el.innerHTML = item.value;
                      el.style.color = this.getRandomRed();
                    }
                  } else if (item.type === "image") {
                    let selector = `span.${component.type}_${item.type} img:nth-child(${index + 1})`;
                    let el = document.querySelector(selector);
                    if (el) {
                      el.src = item.value;
                      // el.style.color = this.getRandomRed();
                    }
                  }
                  if (item.type === "text" && component.type === "button") {
                    let selector = `span.${component.type}s i:nth-of-type(${index + 1})`;
                    let el = document.querySelector(selector);
                    if (el) {
                      el.innerHTML = item.value;
                      el.style.color = this.getRandomRed();
                    }
                  }
                });
              });
            }, 500)
            // set innerHtml end
            this.form.xlsxHead = this.formTemp.reply.head
          }
        }
      } else {
        console.log('No matching phone found');
        this.templates = [];
        // this.form.purposeType = '1'
      }
    },
    async getTemplates(whatsAppId) {
      const templateURL = '/whatsApp/message_templates';
      return await this.axiosRequest(templateURL, {
        waId: whatsAppId
      });
    },
    async getNumberIntegrationList() {
      // // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/mat/number_integration_list';
      return await this.axiosRequest(templateURL, {
        waId: this.waId
      });
    },
    format_date(value) {
      if (value) {
        return moment(value).format('DD-MM-YYYY hh:mm:ss a');
      } else {
        return "";
      }
    },
    async integrationAction(index, mode) {
      this.integratedNumberSearch = '';
      this.form = {
        name: '',
        integrationNumber: '',
        matchingWord: '',
        matchType: 'Exact',
        purposeType: '1',
        deploymentID: '',
        webhookURL: '',
        sheetName: '',
        template: '',
        xlsxHead: {
          'HEADER_DOCUMENT': [],
          'HEADER_IMAGE': [],
          'HEADER_VIDEO': [],
          'HEADER_TEXT': [],
          'BODY_TEXT': [],
          'FOOTER_TEXT': [],
          'BUTTON_URL': [],
          'BUTTON_PAYLOAD': []
        }
      };
      this.dynamicVariables = []
      if (mode == 'edit') {
        this.editID = this.tables[index]._id
        this.form = this.tables[index]
        const editPhone = this.phones.find(
            (option) => option.phonenumber === this.form.integrationNumber
        );
        this.integratedNumberSearch = editPhone ? this.getIntegratedNumberLabel(editPhone) : '';
        this.formTemp = JSON.parse(JSON.stringify(this.tables[index]))
        this.form.purposeType =
            'purposeType' in this.tables[index]
                ? String(this.tables[index].purposeType)
                : '1';

        // load and set template begin
        const modalSizeArray = ['modal-lg', 'modal-md', 'modal-lg', 'modal-md'];
        const purposeType = parseInt(this.form.purposeType, 10);
        const modalSize = modalSizeArray.length > purposeType ? modalSizeArray[purposeType] : 'modal-md';
        this.modalSize = modalSize;
        const selectedPhone = this.phones.find(
            p => p.phonenumber === this.form.integrationNumber
        );
        this.templates = [];
        if (selectedPhone && [0, 2].includes(purposeType) && this.form.matchType == 'Exact') { //  && [0, 2].includes(purposeType)
          console.log(selectedPhone);
          console.log(selectedPhone.whatsAppId);
          if (selectedPhone.whatsAppId && selectedPhone.token.length > 100 && selectedPhone.msg91 == false) {
            const getNumberObj = await this.getTemplates(selectedPhone.whatsAppId)
            if (getNumberObj.data.status && getNumberObj.data.data.data)
              this.templates = getNumberObj.data.data.data;

            // find template index begin
            // const selectedTemplate = this.templates.find(
            //     t => t.name === this.tables[index].reply.template.name
            // );
            const matchedIndex = this.templates.findIndex(
                t => t.name === this.tables[index].reply.template.name
            );
            console.log("matchedIndex ", matchedIndex)

            this.form.template = matchedIndex
            // this.templates[this.form.template] = this.tables[index].reply.template
            this.templateOnChange(false)

            // set innerHtml begin
            setTimeout(() => {
              var previewData = this.extractPreviewData(this.tables[index].reply.data)
              console.log(previewData)
              previewData.forEach(component => {
                component.values.forEach((item, index) => {
                  if (item.type === "text") {
                    let selector = `span.${component.type}_${item.type} i:nth-child(${index + 1})`;
                    let el = document.querySelector(selector);
                    if (el) {
                      el.innerHTML = item.value;
                      el.style.color = this.getRandomRed();
                    }
                  } else if (item.type === "image") {
                    let selector = `span.${component.type}_${item.type} img:nth-child(${index + 1})`;
                    let el = document.querySelector(selector);
                    if (el) {
                      el.src = item.value;
                      // el.style.color = this.getRandomRed();
                    }
                  }
                  if (item.type === "text" && component.type === "button") {
                    let selector = `span.${component.type}s i:nth-of-type(${index + 1})`;
                    let el = document.querySelector(selector);
                    if (el) {
                      el.innerHTML = item.value;
                      el.style.color = this.getRandomRed();
                    }
                  }
                });
              });
            }, 500)
            // set innerHtml end
            // console.log("tables.reply.head ", this.tables[index].reply.head)
            // console.log("form.reply.head ", this.form.xlsxHead)
            // this.form.xlsxHead = this.tables[index].reply.head
            this.form.xlsxHead = JSON.parse(JSON.stringify(this.tables[index].reply.head))
            // setTimeout(() => {
            //   this.dynamicVariables = this.tables[index].reply.head
            // }, 100)

            // find template index end
          }
        } else {
          console.log('No matching phone found');
          this.templates = [];
          // this.form.purposeType = '1'
        }
        // load and set template end
      } else if (mode == 'delete') {
        let _id = this.tables[index]._id
        this.$swal({
          title: 'Are you sure?',
          text: 'you going to delete this lead integration',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(async result => {
          if (result.isConfirmed) {
            let getAxiosRequest = await this.axiosRequest('/whatsApp/mat/number_integration_delete', {_id: _id});

            var responseTitle;
            if (getAxiosRequest.data.status) {
              responseTitle = {title: "Success", icon: "success"};
            } else {
              responseTitle = {title: "Failed", icon: "error"};
            }
            this.sweetAlert(responseTitle.icon, responseTitle.title, getAxiosRequest.data.message, 'btn-primary');
            var getTemp = await this.getNumberIntegrationList();
            this.tables = getTemp.data.message;
          }
        })
      } else {
        let _id = this.tables[index]._id
        this.$swal({
          title: 'Are you sure?',
          text: `you going to ${mode} this lead integration`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: `Yes, ${mode} it!`,
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(async result => {
          if (result.isConfirmed) {
            let getAxiosRequest = await this.axiosRequest('/whatsApp/mat/number_integration_enable_disable', {
              _id: _id,
              mode: mode
            });

            var responseTitle;
            if (getAxiosRequest.data.status) {
              responseTitle = {title: "Success", icon: "success"};
            } else {
              responseTitle = {title: "Failed", icon: "error"};
            }
            this.sweetAlert(responseTitle.icon, responseTitle.title, getAxiosRequest.data.message, 'btn-primary');
            var getTemp = await this.getNumberIntegrationList();
            this.tables = getTemp.data.message;
          }
        })
      }
    },
    extractPreviewData(templateData) {
      const previewData = [];

      if (!templateData?.template?.components) return previewData;

      templateData.template.components.forEach(component => {

        // 🔹 HANDLE BUTTON
        if (component.type === "button") {

          let buttonValues = [];

          if (component.parameters) {
            component.parameters.forEach(param => {

              if (param.type === "text") {
                buttonValues.push({
                  type: "text",
                  value: param.text
                });
              }
            });
          }

          previewData.push({
            type: "button",
            sub_type: component.sub_type || null,
            index: component.index || null,
            values: buttonValues
          });

          return;
        }

        // 🔹 HANDLE HEADER / BODY / FOOTER
        let values = [];

        if (component.parameters) {
          component.parameters.forEach(param => {

            if (param.type === "text") {
              values.push({
                type: "text",
                value: param.text
              });
            }

            if (param.type === "image") {
              values.push({
                type: "image",
                value: param.image?.link || ""
              });
            }

            if (param.type === "video") {
              values.push({
                type: "video",
                value: param.video?.link || ""
              });
            }

            if (param.type === "document") {
              values.push({
                type: "document",
                value: param.document?.link || ""
              });
            }
          });
        }

        if (values.length > 0) {
          previewData.push({
            type: component.type,
            values: values
          });
        }
      });

      return previewData;
    },
    getRandomRed() {
      let r = 150 + Math.floor(Math.random() * 106); // 150–255 (strong red)
      let g = Math.floor(Math.random() * 80);        // low green
      let b = Math.floor(Math.random() * 80);        // low blue
      return `rgb(${r}, ${g}, ${b})`;
    },
    openModelClickMethod() {
      this.editID = '';
      this.integratedNumberSearch = '';
      this.form = {
        name: '',
        integrationNumber: '',
        matchingWord: '',
        matchType: 'Exact',
        purposeType: '1',
        deploymentID: '',
        webhookURL: '',
        sheetName: '',
        template: '',
        xlsxHead: {
          'HEADER_DOCUMENT': [],
          'HEADER_IMAGE': [],
          'HEADER_VIDEO': [],
          'HEADER_TEXT': [],
          'BODY_TEXT': [],
          'FOOTER_TEXT': [],
          'BUTTON_URL': [],
          'BUTTON_PAYLOAD': []
        }
      };
    },
    templateOnChange(getCheck = true) {
      this.dynamicVariables = [];
      this.form.xlsxHead = {
        'HEADER_DOCUMENT': [],
        'HEADER_IMAGE': [],
        'HEADER_VIDEO': [],
        'HEADER_TEXT': [],
        'BODY_TEXT': [],
        'FOOTER_TEXT': [],
        'BUTTON_URL': [],
        'BUTTON_PAYLOAD': []
      };
      this.preview = ""
      this.previewShow = false
      if (this.form.template === '') {
        this.previewShow = false
      } else {
        var strReplace = "";
        var obj = {};
        var tempPreview = []

        // recent file headers set begin
        if (this.form.recentFile !== "" && this.form.recentFile >= 0) {
          this.MainXlsxHeaders = this.recentFiles[this.form.recentFile].data;
          this.xlsxHeaders = Object.keys(this.MainXlsxHeaders[0]);
        }
        // recent file headers set end

        const tempCategory = this.templates[this.form.template].category;
        if (tempCategory.trim().toUpperCase() == "MARKETING" && getCheck) {
          this.$swal({
            title: 'Are you sure?',
            // text: 'you are going to send this message in <strong style="color: #FF0000;">' + tempCategory + '</strong> category.! make sure before sending',
            html: 'you are going to send this message in <strong style="color: #FF0000;">' + tempCategory + '</strong> category.! make sure before sending',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Okay, I have checked!',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
          }).then(async result => {
            if (result.isConfirmed) {
              this.templates[this.form.template].components.forEach((value1) => {
                if (Object.prototype.hasOwnProperty.call(value1, "example")) {
                  if (Object.prototype.hasOwnProperty.call(value1.example, "header_handle") && (value1.format).toLowerCase() == 'document') {
                    obj['HEADER_DOCUMENT'] = value1.example.header_handle;
                    strReplace = value1.example.header_handle;
                    tempPreview.push("<span class='header header_video'>" + "<iframe src='" + strReplace + "' width='335' height='300'></iframe></span>")
                  } else if (Object.prototype.hasOwnProperty.call(value1.example, "header_handle") && (value1.format).toLowerCase() == 'image') {
                    obj['HEADER_IMAGE'] = value1.example.header_handle;
                    strReplace = value1.example.header_handle;
                    tempPreview.push("<span class='header header_image'>" + "<img src='" + strReplace + "' width='335' height='300'></span>")
                  } else if (Object.prototype.hasOwnProperty.call(value1.example, "header_handle") && (value1.format).toLowerCase() == 'video') {
                    obj['HEADER_VIDEO'] = value1.example.header_handle;
                    strReplace = value1.example.header_handle;
                    tempPreview.push("<span class='header header_video'>" + "<iframe src='" + strReplace + "' width='335' height='300'></iframe></span>")
                  } else if (Object.prototype.hasOwnProperty.call(value1.example, "header_text")) {
                    obj['HEADER_TEXT'] = value1.example.header_text;
                    if (value1.text.includes("<i>{{"))
                      strReplace = value1.text
                    else
                      strReplace = value1.text.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>");
                    tempPreview.push("<span class='header header_text font-weight-bold'>" + strReplace + "</span>")
                  } else if (Object.prototype.hasOwnProperty.call(value1.example, "body_text")) {
                    obj['BODY_TEXT'] = value1.example.body_text[0];
                    if (value1.text.includes("<i>{{"))
                      strReplace = value1.text
                    else
                      strReplace = value1.text.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>");
                    tempPreview.push("<span class='body body_text font-weight-bold'>" + strReplace + "</span>")
                  } else if (Object.prototype.hasOwnProperty.call(value1.example, "footer_text")) {
                    obj['FOOTER_TEXT'] = value1.example.footer_text;
                    if (value1.text.includes("<i>{{"))
                      strReplace = value1.text
                    else
                      strReplace = value1.text.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>");
                    tempPreview.push("<span class='footer footer_text font-weight-bold'>" + strReplace + "</span>")
                  }
                } else {
                  if (value1.type == "BUTTONS") {
                    var strReplaceBtn = "";
                    var objUrl = [];
                    value1.buttons.forEach((valueBtn) => {
                      if (Object.prototype.hasOwnProperty.call(valueBtn, "example") && valueBtn.url.includes('{{')) {
                        if (valueBtn.type == 'URL')
                            // obj['BUTTON_URL'] = valueBtn.example;
                          objUrl.push(valueBtn.example);
                        else
                          obj['BUTTON_PAYLOAD'] = valueBtn.example;
                        strReplaceBtn += "<center><span class='buttons font-weight-bold text-decoration-underline text-info text-justify'>" + valueBtn.text + "<br> [URL : " + valueBtn.url.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>") + "]</span></center>";
                      } else {
                        strReplaceBtn += "<center><span class='buttons font-weight-bold text-decoration-underline text-info text-justify'>" + valueBtn.text + "</span></center>";
                      }
                    });
                    obj['BUTTON_URL'] = objUrl; // extra added
                    strReplace = strReplaceBtn;
                  } else
                    strReplace = "<span class='font-weight-bold'>" + value1.text + "</span>";
                  tempPreview.push(strReplace);
                }
                // this.templates[this.form.template].components[index1].text = strReplace;
              })
              this.preview = tempPreview.join('<br><br>');
              this.dynamicVariables = obj;
              if (this.preview) {
                this.previewShow = true;
              }
            } else {
              this.form.template = ''; // or whatever you use to reset the selection
              this.preview = ""
              this.previewShow = false
              return false;
            }
            // if (!result.isConfirmed) {
            //   this.form.template = ''; // or whatever you use to reset the selection
            //   this.preview = ""
            //   this.previewShow = false
            //   return false;
            // }
          });
        } else {
          this.templates[this.form.template].components.forEach((value1) => {
            if (Object.prototype.hasOwnProperty.call(value1, "example")) {
              if (Object.prototype.hasOwnProperty.call(value1.example, "header_handle") && (value1.format).toLowerCase() == 'document') {
                obj['HEADER_DOCUMENT'] = value1.example.header_handle;
                strReplace = value1.example.header_handle;
                tempPreview.push("<span class='header header_video'>" + "<iframe src='" + strReplace + "' width='335' height='300'></iframe></span>")
              } else if (Object.prototype.hasOwnProperty.call(value1.example, "header_handle") && (value1.format).toLowerCase() == 'image') {
                obj['HEADER_IMAGE'] = value1.example.header_handle;
                strReplace = value1.example.header_handle;
                tempPreview.push("<span class='header header_image'>" + "<img src='" + strReplace + "' width='335' height='300'></span>")
              } else if (Object.prototype.hasOwnProperty.call(value1.example, "header_handle") && (value1.format).toLowerCase() == 'video') {
                obj['HEADER_VIDEO'] = value1.example.header_handle;
                strReplace = value1.example.header_handle;
                tempPreview.push("<span class='header header_video'>" + "<iframe src='" + strReplace + "' width='335' height='300'></iframe></span>")
              } else if (Object.prototype.hasOwnProperty.call(value1.example, "header_text")) {
                obj['HEADER_TEXT'] = value1.example.header_text;
                if (value1.text.includes("<i>{{"))
                  strReplace = value1.text
                else
                  strReplace = value1.text.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>");
                tempPreview.push("<span class='header header_text font-weight-bold'>" + strReplace + "</span>")
              } else if (Object.prototype.hasOwnProperty.call(value1.example, "body_text")) {
                obj['BODY_TEXT'] = value1.example.body_text[0];
                if (value1.text.includes("<i>{{"))
                  strReplace = value1.text
                else
                  strReplace = value1.text.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>");
                tempPreview.push("<span class='body body_text font-weight-bold'>" + strReplace + "</span>")
              } else if (Object.prototype.hasOwnProperty.call(value1.example, "footer_text")) {
                obj['FOOTER_TEXT'] = value1.example.footer_text;
                if (value1.text.includes("<i>{{"))
                  strReplace = value1.text
                else
                  strReplace = value1.text.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>");
                tempPreview.push("<span class='footer footer_text font-weight-bold'>" + strReplace + "</span>")
              }
            } else {
              if (value1.type == "BUTTONS") {
                var strReplaceBtn = "";
                var objUrl = [];
                value1.buttons.forEach((valueBtn) => {
                  if (Object.prototype.hasOwnProperty.call(valueBtn, "example") && valueBtn.url.includes('{{')) {
                    if (valueBtn.type == 'URL')
                        // obj['BUTTON_URL'] = valueBtn.example;
                      objUrl.push(valueBtn.example);
                    else
                      obj['BUTTON_PAYLOAD'] = valueBtn.example;
                    strReplaceBtn += "<center><span class='buttons font-weight-bold text-decoration-underline text-info text-justify'>" + valueBtn.text + "<br> [URL : " + valueBtn.url.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>") + "]</span></center>";
                  } else {
                    strReplaceBtn += "<center><span class='buttons font-weight-bold text-decoration-underline text-info text-justify'>" + valueBtn.text + "</span></center>";
                  }
                });
                obj['BUTTON_URL'] = objUrl; // extra added
                strReplace = strReplaceBtn;
              } else
                strReplace = "<span class='font-weight-bold'>" + value1.text + "</span>";
              tempPreview.push(strReplace);
            }
            // this.templates[this.form.template].components[index1].text = strReplace;
          })
          this.preview = tempPreview.join('<br><br>');
          this.dynamicVariables = obj;
          if (this.preview) {
            this.previewShow = true;
          }
        }
      }
    },
    templateOnDynamicChange(divKey, divKey1, divValue, mode = false) {
      var divValueAdd;
      if (mode)
        divValueAdd = divValue;
      else
        divValueAdd = this.MainXlsxHeaders[0][divValue];
      // var getSelectionField = {
      //   'HEADER_IMAGE': "HEADER",
      //   'HEADER_TEXT': "HEADER",
      //   'BODY_TEXT': "BODY",
      //   'FOOTER_TEXT': "FOOTER"
      // };
      if (this.form.template === '') {
        this.preview = ""
        this.previewShow = false
      } else {
        if (divKey == 'HEADER_DOCUMENT') {
          document.querySelectorAll(".header_video iframe")[divKey1].src = divValueAdd;
        } else if (divKey == 'HEADER_IMAGE') {
          document.querySelectorAll(".header_image img")[divKey1].src = divValueAdd;
        } else if (divKey == 'HEADER_VIDEO') {
          document.querySelectorAll(".header_video iframe")[divKey1].src = divValueAdd;
        } else if (divKey == 'HEADER_TEXT') {
          document.querySelectorAll(".header_text i")[divKey1].textContent = divValueAdd;
        } else if (divKey == 'BODY_TEXT') {
          document.querySelectorAll(".body_text i")[divKey1].textContent = divValueAdd;
        } else if (divKey == 'FOOTER_TEXT') {
          document.querySelectorAll(".footer_text i")[divKey1].textContent = divValueAdd;
        } else if (divKey == 'BUTTON_URL') {
          document.querySelectorAll(".buttons i")[divKey1].textContent = divValueAdd;
        }
        this.previewShow = true;
      }
    }
  }
}
</script>
<style>
@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}

.bg-lightblue {
  background-color: lightblue;
}

.ag-grid-container {
  width: 100%;
  overflow: hidden;
}

/*td {*/
/*  white-space: normal !important;*/
/*  word-wrap: break-word;*/
/*}*/
/*table {*/
/*  table-layout: fixed;*/
/*}*/
</style>
